var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('comp-4-goal-blurbs',{attrs:{"section":12,"page":9,"blurbs":_vm.goalBlurbs}})}
var staticRenderFns = []

export { render, staticRenderFns }